import Countdown from '../Countdown/Countdown'

import { useGetGGPRewardsCycleSeconds, useGetGGPRewardsCycleStartTime } from '@/hooks/ggpRewards'

const GGPReward = () => {
  const { data: rewardsCycleStartTime } = useGetGGPRewardsCycleStartTime()
  const { data: rewardsCycleSeconds } = useGetGGPRewardsCycleSeconds()

  const rewardsCycleEndDate =
    rewardsCycleStartTime &&
    rewardsCycleSeconds &&
    new Date(Number(rewardsCycleStartTime + rewardsCycleSeconds))

  if (!rewardsCycleEndDate) return null

  return <Countdown countdown={rewardsCycleEndDate.getTime() - 4 * 60 * 60} />
}

export default GGPReward
